import { useQuery } from '@tanstack/react-query';
import { VER_STAGES, VER_STAGE_LABELS } from '@raro/domain';
import { Glyph, EmptyState, Label, Stepper, Title } from '@raro/ui';
import { Link } from 'react-router';
import { api } from '../lib/api';
import { formatDate } from '../lib/format';
import type { VerOverviewItem } from '../lib/types';

export function VerPage() {
  const list = useQuery({ queryKey: ['ver-overview'], queryFn: () => api.get<VerOverviewItem[]>('/ver/overview') });
  return (
    <div className="rr-page rr-stack rr-stack--7">
      <header className="rr-stack rr-stack--2">
        <Glyph name="ver" size={64} className="rr-page-glyph" /><Label>VER</Label>
        <Title>observar → tornar visível → identificar o comum → contrariar → encontrar → provar.</Title>
        <p className="rr-muted">o workflow intelectual central. cada ciclo passa pelas seis etapas e termina com uma síntese.</p>
      </header>
      {list.isSuccess && list.data.length === 0 && <EmptyState title="nenhum ciclo ativo.">inicie um ciclo num projeto para começar um VER.</EmptyState>}
      <div className="rr-stack rr-stack--3">
        {list.data?.map((v) => (
          <Link key={v.cycle.id} to={`/projetos/${v.project.id}/ver`} className="rr-cycle-row">
            <div className="rr-stack rr-stack--3">
              <div className="rr-row rr-row--wrap" style={{ gap: 'var(--rr-space-3)' }}>
                <span style={{ fontWeight: 600 }}>{v.organization.name.toUpperCase()}</span>
                <span className="rr-faint">{v.project.name} · {v.cycle.name}</span>
                <span className="rr-faint" style={{ fontSize: 'var(--rr-text-xs)' }}>desde {formatDate(v.cycle.startsAt)}</span>
              </div>
              {v.project.currentQuestion && <span className="rr-muted">{v.project.currentQuestion}</span>}
              <Stepper steps={VER_STAGES.map((s) => VER_STAGE_LABELS[s])} current={v.cycle.stage ? VER_STAGES.indexOf(v.cycle.stage) : 0} />
            </div>
            <div className="rr-stage__stats">
              <div className="rr-stage__stat"><b>{v.counts.hypotheses}</b>hipóteses</div>
              <div className="rr-stage__stat"><b>{v.counts.initiatives}</b>iniciativas</div>
              <div className="rr-stage__stat"><b>{v.counts.decisions}</b>decisões</div>
              <div className="rr-stage__stat"><b>{v.counts.suggestionsPending}</b>a julgar</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
